import { CoordinatorService } from './coordinator.service';
import { ScriptRatings } from './script-ratings';
import { ScriptSelectionWidget } from './script-selection-widget';
import { ScriptTags } from './script-tags';

export class ScriptWidget {
    #coords: CoordinatorService;
    #_widget: any;
    id: string;

    constructor(coords: CoordinatorService, widget: any) {
        this.#coords = coords;
        this.#_widget = widget;
        this.id = widget.scriptId;
    }

    display() {
        return this;
    }

    log(prefix = 'Widget') {
        console.log(`${prefix}: ${this.id}`);

        return this;
    }

    fillValue(tag: string, value: any) {
        this.#_widget.fillValue(tag, value);
    }

    open(tag: string) {
        return this.#_widget.open(tag);
    }

    get(tag: string | ScriptTags | ScriptRatings) {
        const isRatings = tag instanceof ScriptRatings;
        const isTags = tag instanceof ScriptTags;

        if (isRatings || isTags) return new ScriptSelectionWidget(this.#coords, tag.id);
        if (this.id === 'selection-board') return new ScriptSelectionWidget(this.#coords, tag);

        return this.#_widget.get(tag);
    }

    private _getPanel(tag: string) {
        tag = tag?.toLowerCase();
        switch (this.id) {
            case 'filter-board':
                for (let p of this.#_widget.panelLs) {
                    if (p.title.toLowerCase() == tag) return p;
                }
                break;
        }
    }

    expand(tag?: string) {
        const fPanel = tag && this._getPanel(tag);
        fPanel && (fPanel.hasDetails = true);
    }

    collapse(tag?: string) {
        const fPanel = tag && this._getPanel(tag);
        fPanel && (fPanel.hasDetails = false);
    }
}
